import React, { useEffect, useState } from 'react';

import { useBreakpoint } from '@techstyle/react-components';
import { FormattedMessage } from '@techstyle/react-intl';
import { useSessionDetail, useSessionActions } from '@techstyle/redux-core';

import { SignUpMethod } from '../../constants/auth';
import {
  GIFT_FORGOT_PASSWORD,
  GIFT_SIGN_IN,
  GIFT_SIGN_UP,
} from '../../constants/signIn';
import { BasicModal } from '../../styles/modal';
import { useLDFlags } from '../../utils/LD/useLDFlags';
import { Component as CloseButton } from '../CloseButton';
import { Container as SignIn } from '../SignIn';

import {
  StyleSitePromo,
  StyledCongrats,
  StyledContainer,
  StyledCreateAccount,
  StyledGiftBoxContainer,
  PromoExpandContainer,
  GiftBoxImage,
  GiftBoxOpenImage,
  GiftForYouText,
  FormContainer,
  StyledGiftForYouSubHeading,
  StyledNewRewardsText,
  StyledSavageLogo,
} from './styles';

let interval;

export function GiftBoxModal() {
  const { 'gift-box-sign-up-modal': isGiftBoxModalEnabled } = useLDFlags();

  const giftBoxSessionDetail = useSessionDetail('GIFTBOX');

  const sessionActions = useSessionActions();

  const [didClickSignIn, setDidClickSignIn] = useState(false);

  const [shouldBeOpen, setShouldBeOpen] = useState(false);

  useEffect(() => {
    if (
      !giftBoxSessionDetail?.value &&
      giftBoxSessionDetail?.networkStatus?.isUpToDate
    ) {
      setShouldBeOpen(true);
    }
  }, [giftBoxSessionDetail]);

  const [toggleState, setToggleState] = useState('');

  const { isMobile } = useBreakpoint();

  const [isAnimationDone, setIsAnimationDone] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [isSignIn, setIsSignIn] = useState(false);

  useEffect(() => {
    if (isClicked) {
      setTimeout(() => {
        const expandContainer = document.getElementById(
          'gift-box-promo-expand-container'
        );

        if (expandContainer) {
          expandContainer.setAttribute('is-active', 'true');
          setTimeout(() => setIsAnimationDone(true), 4000);
        }
      }, 1500);
    }
  }, [isClicked]);

  useEffect(() => {
    const boxIds = ['gift-box-1', 'gift-box-2', 'gift-box-3'];
    let activeIndex = 0;

    clearInterval(interval);

    if (isMobile) {
      interval = setInterval(() => {
        boxIds.forEach(id => {
          const el = document.getElementById(id);
          if (el) {
            el.setAttribute('data-highlight', 'false');
          }
        });

        const activeEl = document.getElementById(boxIds[activeIndex]);
        if (activeEl) {
          activeEl.setAttribute('data-highlight', 'true');
        }

        activeIndex = (activeIndex + 1) % boxIds.length;
      }, 2000);
    }

    return () => clearInterval(interval);
  }, [isMobile]);

  useEffect(() => {
    sessionActions.updateSessionDetail({
      name: 'GIFTBOX',
      value: true,
    });
  }, [sessionActions]);

  useEffect(() => {
    if (!toggleState) {
      return;
    }

    if (toggleState !== GIFT_SIGN_UP) {
      setDidClickSignIn(true);
    }
  }, [toggleState]);

  if (!isGiftBoxModalEnabled) {
    return null;
  }

  return (
    <BasicModal
      onExit={() => setShouldBeOpen(false)}
      isOpen={shouldBeOpen}
      title="gift_box_title"
      closeButton={<CloseButton style={{ color: 'white' }} />}
    >
      <StyledContainer>
        {!isSignIn ? (
          <PromoExpandContainer id="gift-box-promo-expand-container">
            <StyledCongrats>
              <FormattedMessage
                id="gift_box.congrats"
                defaultMessage="Congrats!"
              />
            </StyledCongrats>
            <StyleSitePromo>
              <FormattedMessage
                id="gift_box.promo_message"
                defaultMessage="60% Off <br /> Sitewide"
              />
            </StyleSitePromo>

            {isAnimationDone ? (
              <StyledCreateAccount>
                <FormattedMessage
                  id="gift_box.claim_account"
                  defaultMessage="Create an account to claim your <br /> new rewards member offer."
                />
              </StyledCreateAccount>
            ) : (
              <StyledNewRewardsText>
                <FormattedMessage
                  id="gift_box.new_rewards"
                  defaultMessage="NEW REWARDS MEMBER OFFER"
                />
              </StyledNewRewardsText>
            )}
          </PromoExpandContainer>
        ) : null}

        {!isClicked && !isSignIn ? (
          <StyledSavageLogo src="/static/images/gift_savage_logo.svg" alt="" />
        ) : null}
        {!isClicked && !isSignIn ? (
          <GiftForYouText>
            <FormattedMessage
              id="gift_box.a_gift_for_you"
              defaultMessage="A GIFT JUST <br /> <br /> FOR YOU"
            />
          </GiftForYouText>
        ) : null}
        {!isClicked && !isSignIn ? (
          <StyledGiftForYouSubHeading>
            <FormattedMessage
              id="gift_box.tap_gift"
              defaultMessage="Tap a gift box to unwrap your <br /> exclusive discount!"
              å
            />
          </StyledGiftForYouSubHeading>
        ) : null}
        {!isAnimationDone ? (
          <StyledGiftBoxContainer>
            {isClicked ? (
              <GiftBoxOpenImage src="/static/images/gift_open_new.gif" alt="" />
            ) : null}
            {!isClicked
              ? [0, 0, 0].map((_, index) => {
                  return (
                    <GiftBoxImage
                      key={`gift-box-${index + 1}`}
                      id={`gift-box-${index + 1}`}
                      onClick={() => {
                        setIsClicked(true);
                      }}
                      src="/static/images/giftbox.svg"
                      alt=""
                    />
                  );
                })
              : null}
          </StyledGiftBoxContainer>
        ) : null}
        {isAnimationDone ? (
          <FormContainer data-should-center={`${didClickSignIn}`}>
            <SignIn
              initialScreen={SignUpMethod.GIFT_SIGN_UP}
              showSwitcher={false}
              setToggledState={setToggleState}
              onSuccess={() => {
                setShouldBeOpen(false);

                if (
                  [GIFT_SIGN_IN, GIFT_FORGOT_PASSWORD].includes(toggleState)
                ) {
                  return;
                }

                window.location.href = '/quiz-complete';
              }}
              onSignInClick={() => setIsSignIn(true)}
              extraSignUpData={{
                method: SignUpMethod.GIFT_SIGN_UP,
              }}
            />
          </FormContainer>
        ) : null}
      </StyledContainer>
    </BasicModal>
  );
}
